module.exports = __webpack_public_path__ + "static/img/b-1.d177e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/b-1.png
// module id = jV0U
// module chunks = 0